<a (click)="!!changeApp && changeColor(changeApp)" [routerLink]="linkTo">
  <div
    class="css-button-fully-rounded text-center"
    [ngClass]="!!background ? background : 'btn-info'"
  >
    <p>{{ title }}</p>
  </div>
</a>
